export default [
  {
    id: 'N/A',
    name: 'Select your company',
  },
  {
    id: 'alaska',
    name: 'Alaska Airlines',
  },
  {
    id: 'alliant',
    name: 'Alliant Credit Union',
  },
  {
    id: 'ally',
    name: 'Ally Bank',
  },
  {
    id: 'amex',
    name: 'American Express',
  },
  {
    id: 'ascent',
    name: 'Ascent',
  },
  {
    id: 'bofa',
    name: 'Bank of America',
  },

  {
    id: 'bethpage',
    name: 'Bethpage Federal Credit Union',
  },
  {
    id: 'capitalone',
    name: 'Capital One',
  },
  {
    id: 'chase',
    name: 'Chase',
  },
  {
    id: 'citi',
    name: 'Citibank',
  },
  {
    id: 'collegeave',
    name: 'College Ave',
  },
  {
    id: 'delta',
    name: 'Delta',
  },
  {
    id: 'discover',
    name: 'Discover',
  },
  {
    id: 'fidelity',
    name: 'Fidelity Investments',
  },
  {
    id: 'isl',
    name: 'ISL',
  },
  {
    id: 'ladderlife',
    name: 'Ladder Life',
  },
  {
    id: 'laurelroad',
    name: 'Laurel Road Refinance',
  },
  {
    id: 'lendingclub',
    name: 'LendingClub',
  },
  {
    id: 'lightstream',
    name: 'LightStream',
  },
  {
    id: 'mpower',
    name: 'MPOWER',
  },
  {
    id: 'nbkc',
    name: 'NBKC',
  },
  {
    id: 'nasb',
    name: 'North American Savings Bank',
  },
  {
    id: 'pennymac',
    name: 'PennyMac',
  },
  {
    id: 'risla',
    name: 'RISLA Refinance',
  },
  {
    id: 'schwab',
    name: 'Schwab Bank',
  },
  {
    id: 'sofi',
    name: 'SoFi',
  },
  {
    id: 'statefarm',
    name: 'State Farm',
  },
  {
    id: 'synchrony',
    name: 'Synchrony Bank',
  },
  {
    id: 'tdameritrade',
    name: 'TD Ameritrade',
  },
  {
    id: 'upgrade',
    name: 'Upgrade',
  },
  {
    id: 'usbank',
    name: 'U.S. Bank',
  },
  {
    id: 'vanguard',
    name: 'Vanguard',
  },
  {
    id: 'wealthfront',
    name: 'Wealthfront',
  },
  {
    id: 'wellsfargo',
    name: 'Wells Fargo',
  },
  {
    id: 'worldofhyatt',
    name: 'World of Hyatt',
  },
  {
    id: 'zoefinancial',
    name: 'Zoe Financial',
  },
];
